import { API_URL } from "@/constants/constants";
import axios from "axios";


export default class AuthProvider {
  static async login(credentials) {
    let response = await axios.post(
        API_URL + "/api/login", // Cambia esto por la URL de tu API
        null, // No hay cuerpo para enviar en esta solicitud
        {
          headers: {
            Authorization: `Basic ${credentials}`, // Encabezado Basic Auth
          },
        }
      );
    return response;
  }


}
